import React from 'react';
import { SectionHeading } from './SectionHeading';
export function Intro() {
  return <section aria-labelledby="intro-title" className="relative border-t border-silver/10 bg-carbon py-20 sm:py-28" data-id="element-102" data-mp="27gi7a68xodkl">
      <div aria-hidden="true" className="star-field pointer-events-none absolute inset-0 opacity-60" data-id="element-103" data-mp="2leopke1eg4z5" />
      <div className="relative mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-104" data-mp="2ghpyk4d18e56">
        <SectionHeading id="intro-title" eyebrow="Nuestra labor" title="PRÁCTICAS ESPIRITUALES TRADICIONALES" data-id="element-105" data-mp="1ss3x1a96tmu0">
          <div className="space-y-6 text-center text-[0.98rem] leading-relaxed text-silver sm:text-lg" data-id="element-106" data-mp="22h5dt2nk4891">
            <p data-id="element-107" data-mp="1xqoz7f802gl3">
              Conoce nuestras prácticas tradicionales de brujería, hechicería y
              orientación espiritual. Ofrecemos consultas y rituales
              personalizados para personas que desean explorar diferentes
              aspectos de su vida sentimental, personal y espiritual.
            </p>
            <p data-id="element-108" data-mp="1r55mn4tm79t">
              Cada consulta se aborda de manera personalizada de acuerdo con las
              circunstancias de cada persona y desde una perspectiva de prácticas
              espirituales tradicionales.
            </p>
          </div>
        </SectionHeading>
      </div>
    </section>;
}